import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, ReplaySubject } from 'rxjs';
import { AllExports, RingCentralExportStatus } from '../../shared/models/generated/ziroModels';
import { ActivatedRoute } from '@angular/router';
import { map } from 'rxjs/operators';

@Injectable()
export class MigrationsAssessmentsContext {
  private _http = inject(HttpClient);
  private _route = inject(ActivatedRoute);

  private _stateSource = new ReplaySubject<AllExports>(1);
  state$ = this._stateSource.asObservable();

  private readonly _tenantId: string;

  constructor() {
    this._tenantId = this._route.snapshot.params.tenantId;
    this.refresh().subscribe();
  }

  refresh(): Observable<void> {
    return this._http.get<AllExports>(`/services/microsoft/migrations/tenants/${this._tenantId}/exports`).pipe(
      map((exports) => {
        this._stateSource.next(exports);
      }),
    );
  }

  isExportRefreshing(allExports: AllExports): boolean {
    return allExports.ringCentralExports.some(
      (ringCentralExport) => ringCentralExport.status === RingCentralExportStatus.CREATING,
    );
  }

  setState(allExports: AllExports): void {
    this._stateSource.next(allExports);
  }
}
